export const pageContentWidths = Object.freeze({
	narrow: 800,
	wide: 1200,
	full: undefined,
});
